import { render, staticRenderFns } from "./PaymentFailedHistory.vue?vue&type=template&id=c70e0b32&scoped=true&"
import script from "./PaymentFailedHistory.vue?vue&type=script&lang=js&"
export * from "./PaymentFailedHistory.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFailedHistory.vue?vue&type=style&index=0&id=c70e0b32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70e0b32",
  null
  
)

export default component.exports